import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import urlParse from 'url-parse';
import { postDonationError } from '@client/connectivity/api.donation';

class DonateErrorRoute extends PureComponent {
  componentDidMount() {
    const { location } = this.props;
    const parsedLocationSearch = urlParse(location.search, true);
    postDonationError(
      parsedLocationSearch,
      parsedLocationSearch.query.fundraiserId,
      parsedLocationSearch.query.donationId
    );
  }

  render() {
    return (
      <div>
        <h1 style={{ textAlign: 'center' }}>Din donation misslyckades</h1>
      </div>
    );
  }
}

DonateErrorRoute.propTypes = {
  location: PropTypes.object,
};

export default DonateErrorRoute;
